module.exports = __webpack_public_path__ + "img/中间bg2.194afeb6.png";